module.exports = __webpack_public_path__ + "static/media/langchain-logo.fba77460.png";